import { defineNuxtRouteMiddleware, navigateTo } from '#imports';

// Promo pages whose offers have ended (retired 2026-09-28, when the partner deals moved into the
// /signup funnel - lib/signup/partner-promos.ts). Each sold only through the old /register funnels,
// which nothing links to any more, so an old link, bookmark or search result lands on the product's
// own page instead. Attached per page (definePageMeta), like middleware/wireless-disabled.ts; the
// trailing slash skips the extra hop trailing-slash.global.ts would otherwise add.
const RETIRED_TO: Record<string, string> = {
  '/easter-promo': '/broadband/',
  '/mobile-easter-promo': '/mobile/',
  '/mobile-deal': '/mobile/',
  '/promo-mobile-giftcard': '/mobile/',
  '/promo-mobile': '/mobile/',
};

export const retiredPromoTarget = (path: string): string | null => RETIRED_TO[path.replace(/\/+$/, '')] ?? null;

export default defineNuxtRouteMiddleware((to) => {
  const target = retiredPromoTarget(to.path);
  if (target) return navigateTo(target, { replace: true, redirectCode: 301 });
});
